import React, { createContext, useContext, useState, useEffect, ReactNode, FC } from 'react';
import { trackTimeSpentOnBuilder } from './Analytics';
interface TimeTrackingContextType {
  startTime: number;
  logTimeSpent: () => void;
}

const TimeTrackingContext = createContext<TimeTrackingContextType | undefined>(undefined);

interface TimeTrackingProviderProps {
  children: ReactNode;
}

export const TimeTrackingProvider: FC<TimeTrackingProviderProps> = ({ children }) => {
  const [startTime, setStartTime] = useState<number>(Date.now());

  useEffect(() => {
    const handleBeforeUnload = () => {
      trackTimeSpentOnBuilder(startTime);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      trackTimeSpentOnBuilder(startTime);
    };
  }, [startTime]);

  const logTimeSpent = () => {
    trackTimeSpentOnBuilder(startTime);
  };

  return (
    <TimeTrackingContext.Provider value={{ startTime, logTimeSpent }}>
      {children}
    </TimeTrackingContext.Provider>
  );
};

export const useTimeTracking = (): TimeTrackingContextType => {
  const context = useContext(TimeTrackingContext);
  if (!context) {
    throw new Error('useTimeTracking must be used within a TimeTrackingProvider');
  }
  return context;
};